import { NabcGlyph } from './NabcGlyph';
import { NabcSignificantLetter } from './NabcSignificantLetter';
import { NabcSubpunctisAndPrepunctis } from './NabcSubpunctisAndPrepunctis';

export class NabcNeume {
  private _glyphs: NabcGlyph[];
  private _horizontalSpacingAdjustment?: string;
  private _significantLetters?: NabcSignificantLetter[];
  private _subpunctisAndPrepunctis?: NabcSubpunctisAndPrepunctis[];
  private _errorsCount?: number;

  get glyphs() {
    return this._glyphs;
  }

  get pitch() {
    return this._glyphs[0].pitch.toLowerCase();
  }

  get horizontalSpacingAdjustment() {
    return this._horizontalSpacingAdjustment;
  }

  get significantLetters() {
    return this._significantLetters;
  }

  // get subpunctisAndPrepunctis() {
  //   return this._subpunctisAndPrepunctis;
  // }

  get subpunctis() {
    return this._subpunctisAndPrepunctis?.filter(subpunctisAndPrepunctis => subpunctisAndPrepunctis.isSubpunctus) || [];
  }

  get prepunctis() {
    return this._subpunctisAndPrepunctis?.filter(subpunctisAndPrepunctis => subpunctisAndPrepunctis.isPrepunctus) || [];
  }

  // get errorsCount() {
  //   return this._errorsCount;
  // }

  constructor(
    glyphs: NabcGlyph[],
    horizontalSpacingAdjustment?: string,
    significantLetters?: NabcSignificantLetter[],
    subpunctisAndPrepunctis?: NabcSubpunctisAndPrepunctis[],
    // errorsCount?: number,
  ) {
    this._glyphs = glyphs;
    this._horizontalSpacingAdjustment = horizontalSpacingAdjustment;
    this._significantLetters = significantLetters;
    this._subpunctisAndPrepunctis = subpunctisAndPrepunctis;
    // this._errorsCount = errorsCount;
  }
}
